<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMomMainProjectPlanResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      header-btn-add-disabled
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="search"
                                               class="btn btn-outline-primary btn-sm"
                                               custom-icon="fa fa-solid fa-plus"
                                               :busy="createLoading"
                                               @click="$refs.createPlan.showModal()"
                                    ></em-button>
                                    <em-button type="view"
                                               custom-label="查看主计划详情"
                                               :disabled="$_notChecked"
                                               :busy="viewLoading"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="getCurrentScheduling()"
                                    ></em-button>
                                    <em-button type="import"
                                               :disabled="$_notChecked"
                                               custom-label="主计划排产" show-name
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :busy="scheduling"
                                               @click="openScheduleModal()"
                                    ></em-button>
                                    <em-button type="edit" custom-icon="fa fa-circle-o-notch"
                                               :disabled="$_notChecked"
                                               custom-label="冻结"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :busy="onFreeze"
                                               confirm-text="确认冻结主计划？"
                                               @click="freeze()">
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-circle-o-notch"
                                               :disabled="$_notChecked"
                                               custom-label="解冻"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :busy="onThaw"
                                               confirm-text="确认解冻主计划？"
                                               @click="thaw()">
                                    </em-button>
                                </template>
                                <template #right-header>
                                    <em-button type="edit"
                                               custom-icon="fa-solid fa-cloud-arrow-down"
                                               :disabled="$_notChecked"
                                               :busy="onExporting"
                                               custom-label="导出Mpp"
                                               class="btn btn-outline-primary "
                                               @click="exportMpp()">
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <re-b-modal header="创建主计划" ref="createPlan" @ok="createPlan">
            <div class="d-flex flex-row w-100">
                <template v-for="item of formConfig">
                    <b-button :key="item.key"
                              class="w-50 mr-1"
                              variant="outline-primary"
                              @click="showPicker(item)">
                        {{ labelAfterPick[item.key] ? ('已选择：' + labelAfterPick[item.key]) : item.label }}
                    </b-button>
                </template>
            </div>
        </re-b-modal>
        <em-modal-entity-selector ref="idPicker" disable-store
                                  @entityModalSelectSelected="pickedId"></em-modal-entity-selector>
        <re-b-modal ref="schedule" header="排产" disable-scrollable @ok="doScheduling">
            <diverse-input-group ref="scheduleForm" :configs="inputFormConfig"></diverse-input-group>
        </re-b-modal>
    </div>
</template>
<script>
// Author liang gang qiang
// Date 2023-09-27 08:20:53

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import DiverseInputGroup from "@/components/workflow/stuffs/DiverseInputGroup.vue";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
    name: "sithMomMainProjectPlanListView",
    components: {DiverseInputGroup, ReBModal},
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonApiMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            formConfig: [
                {
                    label: '选择项目',
                    key: 'prpId',
                    entity: 'sithMesPrdProjectPlanPrp',
                    labelKey: 'projectCode'
                },
                {
                    label: '选择主计划模版',
                    key: 'templateId',
                    entity: 'sithMomMainProjectTemplate',
                    labelKey: 'taskName'
                }
            ],
            labelAfterPick: {},
            currentPickItem: null,
            saveForm: {},
            createLoading: false,

            //----scheduling----
            scheduling: false,
            inputFormConfig: [
                {
                    label: '排产策略', name: 'schedulingStrategy', type: 'select', options: [
                        {value: '2', text: '正排'},
                        {value: '3', text: '倒排'}
                    ],
                    require: true,
                    defaultValue: '2'
                },
                {label: '重新排产', name: 'reSchedule', type: 'checkbox', defaultValue: true},
                {label: '开始日期', name: 'startDate', type: 'date'},
                {label: '结束日期', name: 'endDate', type: 'date'},
            ],

            viewLoading: false,

            onFreeze: false,
            onThaw: false,
            onExporting: false,
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        showPicker(item) {
            this.currentPickItem = item;
            this.$refs.idPicker.setCustomVuexConfig(item.entity)
            this.$refs.idPicker.onlyShowModal()
        },
        pickedId(row) {
            if (row == null) {
                this.labelAfterPick[this.currentPickItem.key] = null;
                this.saveForm[this.currentPickItem.key] = null;
            } else {
                this.labelAfterPick[this.currentPickItem.key] = row[this.currentPickItem.labelKey];
                this.saveForm[this.currentPickItem.key] = row.id;
            }
            this.$forceUpdate();
        },
        createPlan() {
            let params = [];
            for (let item of this.formConfig) {
                let key = item.key;
                if (!this.saveForm[key]) {
                    this.$message.warning('请选择' + item.label);
                    return;
                }
                params.push(key + '=' + this.saveForm[key]);
            }
            this.createLoading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectPlan/create?" + params.join('&'),
                data: {}
            }).then(() => {
                this.$message.success("创建成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.createLoading = false);
        },
        //-----
        getCurrentScheduling() {
            this.viewLoading = true;
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectPlan/planDetail?ids=" + this.selectIds
            }).then(response => {
                this.$router.push({
                    name: 'mainProjectPlanAdjust',
                    params: {
                        scheduledResult: response,
                        readOnly: true
                    }
                })
            }).finally(() => this.viewLoading = false);
        },
        openScheduleModal() {
            this.$refs.schedule.showModal();
            this.$nextTick(() => this.$refs.scheduleForm.initInputData({
                startDate: this.checkedRows[0].mainBeginTime
            }))
        },
        doScheduling() {
            this.scheduling = true;
            let form = this.$refs.scheduleForm.getInputData();
            let reSchedule = form.reSchedule;
            if (reSchedule) {
                form.planIds = this.selectIds;
            } else {
                form = null;
            }
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectPlan/scheduling" + (reSchedule ? '' : '/continue'),
                data: form
            }).then(response => {
                this.$router.push({
                    name: 'mainProjectPlanAdjust',
                    params: {
                        scheduledResult: response.data
                    }
                })
            }).finally(() => this.scheduling = false);
        },
        freeze() {
            this.onFreeze = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/freeze?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {}).then(() => {
                commonViewsUtil.showSuccess(this, "冻结主计划成功")
                this.$refs.emListFilter.doQuery()
            }).finally(() => this.onFreeze = false)

        },
        thaw() {
            this.onThaw = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/thaw?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {}).then(() => {
                commonViewsUtil.showSuccess(this, "解冻主计划成功")
                this.$refs.emListFilter.doQuery()
            }).finally(() => this.onThaw = false)
        },
        exportMpp() {
            if (this.$_checked) {
                this.onExporting = true;
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectPlan/exportMpp",
                    data: this.checkedItems
                }).then(() => this.$message.success("操作成功，请留意小铃铛消息"))
                    .finally(() => this.onExporting = false);
            } else {
                this.$message.warning("请先勾选")
            }
        },
    }
};
</script>
